import React, { useReducer, useMemo } from "react";
import { Table, Input, Select, Spin, Statistic, Card } from "antd";
import { reducer } from "../../../Utils/CommonUtils";
import { useFetch } from "../../../Utils/useFetch";
import { FETCH_ALL_COUNTER_API } from "../../../Constants/Apis";
import { getStocksNotInOpname } from "../../../Services/StockService";

const { Search } = Input;

const StockNotInOpnamePage = ({ history, userData, forcedCounterCode }) => {
  const initialState = {
    current: 1,
    pageSize: 10,
    counterCode: forcedCounterCode || undefined,
  };

  const [state, dispatch] = useReducer(reducer, initialState);

  const { fetchedData: counterFetched = {} } = useFetch(
    FETCH_ALL_COUNTER_API,
    {}
  );
  const counterOptions = useMemo(
    () =>
      (counterFetched?.data || []).map((c) => ({
        label: c.code,
        value: c.code,
      })),
    [counterFetched?.data]
  );

  const fetcher = useMemo(() => {
    return {
      url: null,
      call: () =>
        getStocksNotInOpname({
          current: state.current,
          pageSize: state.pageSize,
          counterCode: state.counterCode,
        }),
    };
  }, [state.current, state.pageSize, state.counterCode]);

  const [loading, setLoading] = React.useState(false);
  const [data, setData] = React.useState([]);
  const [pagination, setPagination] = React.useState({
    current: 1,
    pageSize: 10,
    total: 0,
    totalQuantity: 0,
  });

  const loadData = React.useCallback(async () => {
    setLoading(true);
    try {
      const resp = await fetcher.call();
      const payload = resp?.data || {};
      setData(payload.data || []);
      setPagination(
        payload.pagination || {
          current: 1,
          pageSize: 10,
          total: 0,
          totalQuantity: 0,
        }
      );
    } finally {
      setLoading(false);
    }
  }, [fetcher]);

  React.useEffect(() => {
    if (state.counterCode) {
      loadData();
    } else {
      setData([]);
      setPagination((p) => ({ ...p, total: 0, totalQuantity: 0 }));
    }
  }, [loadData, state.counterCode]);

  const handlePaginationChange = (current, pageSize) => {
    dispatch({ type: "current", payload: current });
    dispatch({ type: "pageSize", payload: pageSize });
  };

  const columns = [
    { title: "Counter Code", dataIndex: "counterCode", key: "counterCode" },
    { title: "Barcode", dataIndex: "barcode", key: "barcode" },
    { title: "Article", dataIndex: "article", key: "article" },
    {
      title: "Current Quantity",
      dataIndex: "currentQuantity",
      key: "currentQuantity",
    },
  ];

  return (
    <div
      style={{
        width: "100vw",
        padding: 20,
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 12,
      }}
    >
      <div style={{ width: "80vw", maxWidth: "100vw" }}>
        <div
          style={{
            display: "flex",
            gap: 12,
            alignItems: "center",
            flexWrap: "wrap",
            marginBottom: 12,
          }}
        >
        {!forcedCounterCode && (
          <Select
            allowClear
            style={{ minWidth: 220 }}
            placeholder="Filter by Counter Code (optional)"
            options={counterOptions}
            value={state.counterCode}
            showSearch
            onChange={(v) => {
              dispatch({ type: "counterCode", payload: v });
              dispatch({ type: "current", payload: 1 });
            }}
          />
        )}
          <Card size="small" style={{ minWidth: 220 }}>
            <Statistic
              title="Total Quantity (All)"
              value={pagination.totalQuantity || 0}
            />
          </Card>
        </div>
      </div>

      <Spin spinning={loading}>
        <Table
          columns={columns}
          dataSource={data}
          rowKey={(r) => r.barcode}
          pagination={{
            current: pagination.current || state.current,
            pageSize: pagination.pageSize || state.pageSize,
            total: pagination.total || 0,
            showSizeChanger: true,
            onChange: handlePaginationChange,
          }}
        />
      </Spin>
    </div>
  );
};

export default StockNotInOpnamePage;
